export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  contactMaxChar: 80
}